import { render, staticRenderFns } from "./MainTextAlert.vue?vue&type=template&id=2beede96&"
import script from "./MainTextAlert.vue?vue&type=script&lang=js&"
export * from "./MainTextAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports